import { render, staticRenderFns } from "./modifyChild.vue?vue&type=template&id=321db580&scoped=true"
import script from "./modifyChild.vue?vue&type=script&lang=js"
export * from "./modifyChild.vue?vue&type=script&lang=js"
import style0 from "./modifyChild.vue?vue&type=style&index=0&id=321db580&lang=css"
import style1 from "./modifyChild.vue?vue&type=style&index=1&id=321db580&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321db580",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('321db580')) {
      api.createRecord('321db580', component.options)
    } else {
      api.reload('321db580', component.options)
    }
    module.hot.accept("./modifyChild.vue?vue&type=template&id=321db580&scoped=true", function () {
      api.rerender('321db580', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/organizationChild/child/modifyChild.vue"
export default component.exports